import { atom } from 'recoil'
import { persistAtom } from '../persist'

export const drawerState = atom<boolean>({
  key: 'drawerState',
  default: true,
  effects_UNSTABLE: [persistAtom],
})
